import React, { useRef } from 'react';
import styled from 'styled-components';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { GridRow, GridItem, gridConfig } from '@tvg/fuse-design';
import AlertsComponent from 'components/Alert/AlertsComponent';
import allItemsOutOfStock from 'utilities/sku/isAllOptionsOutOfStock';
import { StockCode } from 'types/ProductResponseType';
import { useExperimentsContext } from 'context/ExperimentsContext';
import { ProductPriceAmount } from 'types/Product';
import AddToBasketButton from './AddToBasketButton';
import StickyAddToBasketButton from './StickyAddToBasketButton';

const DesktopOnly = styled.div`
  @media (max-width: calc(${gridConfig.l.minWidth} - 0.02px)) {
    display: none;
  }
`;

const MobileOnly = styled.div`
  @media (min-width: ${gridConfig.l.minWidth}) {
    display: none;
  }
`;

interface Props {
  productData: {
    price: ProductPriceAmount;
    reviewTotal?: number;
    reviewStars?: number;
  };
}

function AddToBasket({ productData }: Props) {
  const {
    errorMessage,
    handleDigitalDownloadDialogueRender,
    handleAddToBasket,
    hasError,
    digitalDownload,
    skus,
    selectedSku,
    amendBasketEnabled,
    isAddingToBasket,
    isAtbDisabled,
  } = useSelectedSkuContext();

  const primaryAddToBasketButtonRef = useRef<HTMLDivElement>(null);
  const experiments = useExperimentsContext();
  const challengerEnabled = experiments['se-8'];

  const isDisabled =
    isAddingToBasket ||
    isAtbDisabled ||
    allItemsOutOfStock(skus) ||
    selectedSku?.stock?.code === StockCode.OUTOFSTOCK ||
    selectedSku?.stock?.code === StockCode.UNAVAILABLE;

  const atbHandler = digitalDownload ? handleDigitalDownloadDialogueRender : handleAddToBasket;

  return (
    <div data-cnstrc-btn="add_to_cart" data-testid="add-to-basket">
      {challengerEnabled ? (
        <>
          <DesktopOnly>
            {hasError && (
              <GridRow>
                <GridItem xxs={12}>
                  <AlertsComponent errorMessage={errorMessage} />
                </GridItem>
              </GridRow>
            )}
            <AddToBasketButton
              ref={primaryAddToBasketButtonRef}
              handleAddToBasket={atbHandler}
              disabled={isDisabled}
              updateBasket={amendBasketEnabled}
            />
          </DesktopOnly>

          <MobileOnly>
            <StickyAddToBasketButton
              primaryAddToBasketButtonRef={primaryAddToBasketButtonRef}
              handleAddToBasket={atbHandler}
              disabled={isDisabled}
              updateBasket={amendBasketEnabled}
              errorMessage={hasError ? errorMessage : undefined}
              productData={productData}
            />
          </MobileOnly>
        </>
      ) : (
        <>
          {hasError && (
            <GridRow>
              <GridItem xxs={12}>
                <AlertsComponent errorMessage={errorMessage} />
              </GridItem>
            </GridRow>
          )}
          <AddToBasketButton
            ref={primaryAddToBasketButtonRef}
            handleAddToBasket={atbHandler}
            disabled={isDisabled}
            updateBasket={amendBasketEnabled}
          />
          <StickyAddToBasketButton
            primaryAddToBasketButtonRef={primaryAddToBasketButtonRef}
            handleAddToBasket={atbHandler}
            disabled={isDisabled}
            updateBasket={amendBasketEnabled}
            errorMessage={hasError ? errorMessage : undefined}
            productData={productData}
          />
        </>
      )}
    </div>
  );
}

export default AddToBasket;
